import * as React from 'react';
const DisplayOrder = React.memo(function EventTypes(props: any) {
  return <div aria-label="Display Order" className={`flex justify-center items-center pt-[0px]`}>
      {props.value}
    </div>;
});
export default DisplayOrder;